module.exports = __webpack_public_path__ + "static/media/logowom.97852189.svg";